import React from 'react';
import { IOldIconProps } from './type';

const SocialInstagram: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 .852c-3.259 0-3.668.013-4.948.072-1.277.058-2.15.26-2.912.558a5.882 5.882 0 00-2.126 1.384A5.882 5.882 0 00.63 4.99c-.297.763-.5 1.636-.558 2.913C.014 9.184 0 9.593 0 12.852c0 3.259.014 3.667.072 4.947.058 1.277.261 2.15.558 2.913.307.79.717 1.458 1.384 2.125a5.883 5.883 0 002.126 1.385c.763.296 1.635.5 2.912.557 1.28.059 1.689.073 4.948.073 3.259 0 3.668-.014 4.948-.073 1.277-.058 2.15-.26 2.912-.557a5.883 5.883 0 002.126-1.385 5.882 5.882 0 001.384-2.125c.297-.763.5-1.636.558-2.913.058-1.28.072-1.688.072-4.947 0-3.26-.014-3.668-.072-4.948-.059-1.277-.261-2.15-.558-2.913a5.882 5.882 0 00-1.384-2.125 5.882 5.882 0 00-2.126-1.384c-.763-.297-1.635-.5-2.912-.558C15.668.865 15.259.852 12 .852zm0 2.162c3.204 0 3.584.012 4.849.07 1.17.053 1.805.249 2.228.413.56.218.96.478 1.38.898.42.42.68.82.898 1.38.164.422.36 1.058.413 2.228.058 1.265.07 1.644.07 4.849 0 3.204-.012 3.583-.07 4.849-.053 1.17-.249 1.805-.413 2.228-.218.56-.478.96-.898 1.38-.42.42-.82.68-1.38.897-.423.165-1.058.36-2.228.413-1.265.058-1.645.07-4.849.07s-3.584-.012-4.849-.07c-1.17-.053-1.805-.248-2.228-.413a3.718 3.718 0 01-1.38-.897c-.42-.42-.68-.82-.898-1.38-.164-.423-.36-1.058-.413-2.228-.058-1.266-.07-1.645-.07-4.85 0-3.204.012-3.583.07-4.848.053-1.17.249-1.806.413-2.229.218-.56.478-.96.898-1.38.42-.42.82-.68 1.38-.897.423-.164 1.058-.36 2.228-.413 1.265-.058 1.645-.07 4.849-.07zm0 3.675a6.162 6.162 0 100 12.325 6.162 6.162 0 000-12.325zm0 10.163a4 4 0 110-8 4 4 0 010 8zm7.846-10.406a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="translate(0 .852)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SocialInstagram;
